module.exports = __webpack_public_path__ + "static/media/steam.ac79c659.svg";